// removed by extract-text-webpack-plugin
module.exports = {"follow":"Follow-cssmodule-follow-2x4_P","title":"Follow-cssmodule-title-Jrz6Y","bigTitleIcon":"Follow-cssmodule-bigTitleIcon-V2YxO","wrapperView":"Follow-cssmodule-wrapperView-1lhWB","contentView":"Follow-cssmodule-contentView-3rrvB","center":"Follow-cssmodule-center-2a-5l","media":"Follow-cssmodule-media-1l-Vt","content":"Follow-cssmodule-content-2lijI","editorBlock":"Follow-cssmodule-editorBlock-1buTA","buttonView":"Follow-cssmodule-buttonView-iGX4e","button":"Follow-cssmodule-button-3zkm9"};


//////////////////
// WEBPACK FOOTER
// ./components/ModalSet/Follow.cssmodule.less
// module id = 652
// module chunks = 0